import {SlInput, SlSelect} from '@shoelace-style/shoelace/shoelace';
import ShoelaceFormValidator from '../../../../../../library/clxProductNet/assets/js/modules/common/shoelaceFormValidator';
import Toast from '../../../../../../library/clxProductNet/assets/js/modules/common/toast';
import CloudflareTurnstile from '../../../../../../library/clxProductNet/assets/js/modules/turnstile/cloudflareTurnstile';
import {getLocale} from '../../common/locale';

export default class FeCmsContactForm {
    contactForm: HTMLFormElement;

    formLocation: string;

    contactFormTurnstile: CloudflareTurnstile | undefined;

    constructor(contactForm: HTMLFormElement) {
        this.contactForm = contactForm;
        this.formLocation = window.location.pathname + window.location.search + window.location.hash;

        this.prepareTurnstile();
        this.attachListeners();
    }

    attachListeners() {
        const formValidator = new ShoelaceFormValidator(this.contactForm, getLocale(), '');
        formValidator.attachListener();

        this.contactForm.addEventListener('submit', async (event) => {
            event.preventDefault();

            // if CF is not ready, the user shouldn't be able to click the button
            if (!this.contactFormTurnstile) {
                return false;
            }

            const token = this.contactFormTurnstile.getToken();
            if (!token) {
                return false;
            }

            const formData = new FormData(this.contactForm);
            formData.set('formLocation', this.formLocation);

            await this.postForm(formData);
        });
    }

    async postForm(formData: FormData) {
        const t = new Toast('contact-form-validation');
        t.removeAllToasts();

        const req = await fetch(`/${getLocale()}/contact/apiFormSubmit/`, {
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            method: 'post',
            cache: 'no-cache',
            credentials: 'same-origin',
            body: formData,
        });
        const response = await req.json();

        if (response.success === true) {
            location.href = response.redirect;
            return;
        }

        const errors = response.errors;
        if (Array.isArray(errors)) {
            const inputs = Array.from(this.contactForm.querySelectorAll('sl-input,sl-select')) as (SlInput | SlSelect)[];
            for (const input of inputs) {
                input.classList.remove('invalid');
                input.dataset.invalid = 'false';
                for (const error of errors) {
                    if (input.name === error.field) {
                        input.classList.add('invalid');
                        let tMessage = `<sl-icon slot="icon" name="exclamation-octagon"></sl-icon><p>${error.message}</p>`;
                        t.createToast('danger', tMessage);
                        input.dataset.invalid = 'true';
                    }
                }
            }
        }
    }

    private prepareTurnstile() {
        this.contactFormTurnstile = new CloudflareTurnstile('.form-field.turnstile', '.form-field.form-submit sl-button');

        this.contactFormTurnstile.renderWidget();
    }
}
